import React from 'react'
import { ReactComponent as CaretDown } from "../../svg/caret-down.svg";

export default class PermissionsDropdown extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      updated: false,
      selectOpen: false,
      selectedOption: {
        value: 'edit',
        selected: true,
        label: 'Can edit'
      },
      options: [
        {
          value: 'view',
          show: true,
          label: 'Can view'
        },
        {
          value: 'edit',
          show: true,
          label: 'Can edit'
        }
      ]
    }
  }

  componentDidMount(){
    if(!this.state.updated){
      this.syncState()
    }
  }

  syncState(){
    const { activeValue, showNone } = this.props
    const val = typeof(activeValue) === 'string' ? activeValue : activeValue.value
    const opts = this.state.options.map(item => {
      return {
        ...item,
        show: this.props.available.includes(item.value)
      }
    })
    const none = opts.find(({ value }) => value === 'none')
    if(showNone && !none){
      const opt = { value: 'none', label: 'None' }
      opts.unshift(opt)
    }
    const selected = opts.find(({ value }) => value === val)
    if(!selected){
      return
    }
    selected.selected = true
    this.setState({ selectedOption: selected, updated: true, options: opts })
  }

  handleSelect(id){
    const option = this.state.options.find(({ value }) => value === id)
    this.setState({ selectedOption: option })
    this.props.selectPermission(option)
    this.toggleDropdown()
  }

  toggleDropdown(){
    if(this.props.single){
      return
    }
    this.setState({ selectOpen: !this.state.selectOpen })
  }

  render(){
    const { options, selectOpen } = this.state
    const { single } = this.props
    const opts = single ? options[0] : options
    return (
      <div className='permissions-dropdown'>
        <div 
          className='permissions-dropdown__selected'
          onClick={this.toggleDropdown.bind(this)}
        >
          <span 
            className='permissions-dropdown__selected__label'>
            {this.state.selectedOption.label}
            {single ? undefined : <CaretDown />}
          </span>
        </div>
        {selectOpen ? (
          <div className='permissions-dropdown__options'>
            {
              opts.map(option => (
                option.show ? (
                  <div 
                    key={option.value}
                    className='permissions-dropdown__option'
                    onClick={() => this.handleSelect(option.value)}
                  >
                    <span className='permissions-dropdown__option__label'>
                      {option.label}
                    </span>
                  </div>
                )
                :
                undefined
              ))
            }
          </div>
        )
        :
        undefined}
      </div>
    )
  }

}